export function setUser(data) {
    return { type: "SET_USER", user: data }
}
export function setCuenta(data) {
    return { type: "SET_CUENTA", cuenta: data }
}